const InitialState = {
	machineID: "",
	location: "",
	kitchenId: "",
	restaurantTimeZone: "",
};

export const landing = (state = InitialState, action) => {
	switch (action.type) {
		case "SET_MACHINE_ID":
			return {
				...state,
				machineID: action.data._id,
				location: action.data.name,
				kitchenId: action.data.kitchenId,
				restaurantTimeZone: action.data.timeZone || "",
			};

		default:
			return {
				...state,
			};
	}
};

export default landing;
